import { z } from "zod";

const PhysicalExamSectionSchema = z.object({
  normal: z.boolean().optional(),
  notNormal: z.boolean().optional(),
  declined: z.boolean(),
  normalDetails: z.array(z.string()),
  notNormalDetails: z.array(z.string()),
});

const SingleChoiceSchema = z.object({
  singleChoice: z.boolean(),
  declined: z.boolean(),
  singleChoiceDetails: z.array(z.string()),
});

export const PhysicalExamFormSchema = z
  .object({
    sections: z.record(z.string(), z.union([PhysicalExamSectionSchema, SingleChoiceSchema])),
    notes: z.string(),
  })
  .superRefine((data, ctx) => {
    Object.entries(data.sections).forEach(([sectionId, section]) => {
      if (section.declined) {
        return;
      }

      if ("normal" in section) {
        if (section.normal && section.normalDetails.length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["sections", sectionId, "normalDetails"],
            message: "Please select at least one item",
          });
        }
      }

      if ("singleChoice" in section) {
        if (section.singleChoice && section.singleChoiceDetails.length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["sections", sectionId, "singleChoiceDetails"],
            message: "Please select at least one item",
          });
        }
      }
    });
  });

export type PhysicalExamForm = z.infer<typeof PhysicalExamFormSchema>;
export type PhysicalExamSectionField = z.infer<typeof PhysicalExamSectionSchema>;
export type SingleChoiceField = z.infer<typeof SingleChoiceSchema>;
